// FIRESTORE COMPLIANT API CALLS
const getCafeMedia = async (language_code) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getCafeMedia/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => json)
    .catch((error) => {
      console.log(error);
    });
};

const getLocalisedCafeMedia = async (language_code) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getLocalisedCafeMedia/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => json)
    .catch((error) => {
      console.log(error);
    });
};

const getLocalisedCafeMediaByParentId = async (language_code, parent_id) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getLocalisedCafeMediaByParentId/${language_code}/${parent_id}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      //console.log("json response: ", json);
      if (json.code === 404) {
        throw new Error("404: File not found");
      }
      return json;
    })
    .catch((error) => {
      throw error;
    });
};

const getCafeFeatured = async (language_code, category = "Opinion") => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getCafeFeatured/${language_code}/${category}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => json)
    .catch((error) => {
      console.log(error);
    });
};

const getCafeLatest = async (language_code, category = "news") => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getCafeLatest/${language_code}/${category}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => json)
    .catch((error) => {
      console.log(error);
    });
};

const getCafeMediaBySlug = async (language_code, slug) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getCafeMediaBySlug/${language_code}/${slug}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      //console.log("getAcademyMedia(): ", json);
      return json;
    })
    .catch((error) => {
      console.log(error);
      return undefined;
    });
};

export {
  getCafeMedia,
  getLocalisedCafeMedia,
  getLocalisedCafeMediaByParentId,
  getCafeFeatured,
  getCafeLatest,
  getCafeMediaBySlug,
};
